import { createReducer, on } from '@ngrx/store';
import { Config, ConfigEditorDetailVariant } from '../../domain/config';
import * as Actions from './general-config-editor-screen.actions';

export const featureKey = 'cxbGeneralConfigEditorScreen';

export interface FeatureState {
  configs: Config[];
  config: Config;
  variant: ConfigEditorDetailVariant;
  loading: boolean;
}

export interface AppState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  configs: undefined,
  config: undefined,
  variant: undefined,
  loading: false,
};

export const reducer = createReducer(
  initialState,
  on(Actions.loadCxbGeneralConfigEntries, (state): FeatureState => ({ ...state, configs: undefined, loading: true })),
  on(Actions.loadCxbGeneralConfigEntriesSuccess, (state, action): FeatureState => ({ ...state, configs: action.configs, loading: false })),
  on(Actions.loadCxbGeneralConfigEntriesFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.loadCxbGeneralConfigEntry, (state): FeatureState => ({ ...state, config: undefined, loading: true })),
  on(
    Actions.loadCxbGeneralConfigEntrySuccess,
    (state, action): FeatureState => ({ ...state, config: action.config, variant: action.variant, loading: false })
  ),
  on(Actions.loadCxbGeneralConfigEntryFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.leaveConfigEditorDetailScreen, (state): FeatureState => ({ ...state, config: undefined, variant: undefined })),

  on(Actions.createCxbGeneralConfigEntry, (state): FeatureState => ({ ...state, loading: true })),
  on(Actions.createCxbGeneralConfigEntrySuccess, (state): FeatureState => ({ ...state, loading: false })),
  on(Actions.createCxbGeneralConfigEntryFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.updateCxbGeneralConfigEntry, (state): FeatureState => ({ ...state, loading: true })),
  on(Actions.updateCxbGeneralConfigEntrySuccess, (state): FeatureState => ({ ...state, loading: false })),
  on(Actions.updateCxbGeneralConfigEntryFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.deleteCxbGeneralConfigEntry, (state): FeatureState => ({ ...state, loading: true })),
  on(Actions.deleteCxbGeneralConfigEntrySuccess, (state): FeatureState => ({ ...state, loading: false })),
  on(Actions.deleteCxbGeneralConfigEntryFail, (state): FeatureState => ({ ...state, loading: false }))
);
